import { convertEnumToArray } from '@/utils/formatters';
import { Box, TextField, Typography } from '@mui/material';
import SelectField from 'app/shared-components/Forms/Selects/SelectField';
import { ContactTypeOptions, User } from 'app/shared-components/Types/Users';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Language } from 'app/shared-components/Types/Utils';
import PhoneInput from 'app/shared-components/Forms/Inputs/PhoneInput';

const userInformation: { id: keyof User; fieldName: string }[] = [
  {
    id: 'workPhone',
    fieldName: 'Work Phone',
  },
  {
    id: 'workEmail',
    fieldName: 'Work Email',
  },
  {
    id: 'paymentHandle',
    fieldName: 'Payment Handle',
  },
  {
    id: 'paymentNotes',
    fieldName: 'Payment Notes',
  },
];

const languagesData = convertEnumToArray(Language);
const contactTypesData = convertEnumToArray(ContactTypeOptions);

const AddUserAdditionalDetailsForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Box className='flex flex-col items-center justify-center w-full py-8'>
      <Typography variant='h4' className='pt-32' component='h4'>
        Additional Details
      </Typography>
      <SelectField name='languageId' label='Language' data={languagesData} required={true} />
      {userInformation.map(({ id, fieldName }) => {
        return (
          <Box className='flex flex-row items-center justify-center w-full py-8' key={id}>
            <Controller
              name={id}
              control={control}
              defaultValue=''
              render={({ field }) => {
                const err = errors[id]?.message as string;
                if (id === 'workPhone') {
                  return (
                    <PhoneInput
                      value={field.value}
                      onChange={field.onChange}
                      error={!!errors[id]}
                      helperText={err}
                      label={fieldName}
                      size='small'
                      className='w-full'
                    />
                  );
                }
                return (
                  <TextField
                    {...field}
                    label={fieldName}
                    size='small'
                    variant='outlined'
                    className='w-full'
                    error={!!errors[id]}
                    helperText={err}
                  />
                );
              }}
            />
          </Box>
        );
      })}
      <SelectField name='contactType' label='Contact Type' data={contactTypesData} />
    </Box>
  );
};

export default memo(AddUserAdditionalDetailsForm);
